import { render, staticRenderFns } from "./Revaluation.vue?vue&type=template&id=34cf4784&scoped=true"
import script from "./Revaluation.vue?vue&type=script&lang=js"
export * from "./Revaluation.vue?vue&type=script&lang=js"
import style0 from "./Revaluation.vue?vue&type=style&index=0&id=34cf4784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf4784",
  null
  
)

export default component.exports